export const commonStrings = {
  // 通用操作
  confirm: '確認',
  cancel: '取消',
  save: '儲存',
  delete: '刪除',
  edit: '編輯',
  add: '新增',
  enterManagement: '進入管理',
  search: '搜尋',
  reset: '重置',
  loading: '載入中...',
  noData: '尚無資料',
  error: '錯誤',
  success: '成功',
  warning: '警告',
  close: '關閉',
  back: '返回',
  next: '下一步',
  previous: '上一步',
  submit: '提交',
  export: '匯出',
  import: '匯入',
  refresh: '重新整理',
  filter: '篩選',
  sort: '排序',
  select: '選擇',
  all: '全部',
  none: '無',
  yes: '是',
  no: '否',

  // 狀態
  enabled: '啟用',
  disabled: '停用',
  online: '連線',
  offline: '離線',
  active: '啟用',
  inactive: '停用',
  status: '狀態',

  // 基本屬性
  name: '名稱',
  description: '描述',
  type: '類型',
  date: '日期',
  time: '時間',
  createTime: '創建時間',
  updateTime: '更新時間',
  operator: '操作員',

  // 新增通用翻譯
  dateRange: '日期範圍',
  actions: '操作',
  batchOperation: '批次操作',
  itemsPerPage: '每頁顯示',
  goToPage: '跳轉到',
  lastRefresh: '最後更新',
  remark: '備註',

  // 表單驗證
  required: '必填',
  invalid: '無效',
  tooLong: '過長',

  // 操作結果
  saveSuccess: '保存成功',
  deleteSuccess: '刪除成功',
  updateSuccess: '更新成功',
  createSuccess: '創建成功',
  operationSuccess: '操作成功',
  operationFailed: '操作失敗',

  // 系統相關
  admin: '管理員',
  company: 'XXX公司',
  system: '系統'
};

export const statusOptions = {
  active: '啟用',
  inactive: '停用',
  draft: '草稿',
  enabled: '啟用',
  disabled: '停用',
  online: '連線',
  offline: '離線'
};

export const typeOptions = {
  fuxa: 'FUXA',
  custom: '自訂',
  template: '模板',
  chart: '圖表',
  list: '列表',
  quickActions: '快速操作'
};

export const colorOptions = {
  primary: '主要',
  success: '成功',
  error: '錯誤',
  info: '資訊',
  warning: '警告'
};

export const sizeOptions = {
  small: '小',
  medium: '中',
  large: '大'
};
